import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline } from '@atlaskit/primitives/inline';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import type { SearchConfluencePageBlogAttachment } from '@atlassian/dynamic-cards-search-client/graphql/confluence';

import SearchMetadataGeneric from '../../../../../../../../common/ui/search-metadata-generic';
import SearchMetadataLink from '../../../../../../../../common/ui/search-metadata-link';
import { getBaseUrl } from '../../../../../../../../common/utils/url';

const breadcrumbsContainerStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	height: 'size.100',
	maxWidth: '246px', // Specified in the design
});

type ConfluenceResultMetaProps = {
	partial: SearchConfluencePageBlogAttachment;
};

export const ConfluenceResultMeta = ({
	partial: { space, url },
}: ConfluenceResultMetaProps): React.JSX.Element | null => {
	if (!space || !space.name) {
		return null;
	}

	const baseUrl = url && getBaseUrl(url);
	const href = `${baseUrl}/wiki${space.webUiLink}`;

	return (
		<Inline xcss={breadcrumbsContainerStyles}>
			{href ? (
				<SearchMetadataLink label={space.name} href={href} />
			) : (
				<SearchMetadataGeneric label={space.name} />
			)}
		</Inline>
	);
};
